import React, { useEffect, useRef ,useState} from "react";
import styled from "styled-components";
import i18n from 'i18next'
import { CSSTransition } from 'react-transition-group';
import { useTranslation, Trans, useSSR } from "react-i18next";
import { Flex, Tooltip, Typography } from "antd";
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import FormHeader from "../form/FormHeader";
import FormTitle from "../form/FormTitle";
import FormField from "../form/FormField";
import FormText from "../form/FormText";
import FormLabel from "../form/FormLabel";
import FormInput from "../form/FormInput";
import FormRemark from "../form/FormRemark";
import _FormInputError from "../form/FormInputError";
import FormBigCheckbox2 from "../form/FormBigCheckbox2";
import FormDatePicker from "../form/FormDatePicker";
import FormButtonSecondary from "../form/FormButtonSecondary";
import FormButtonDanger from "../form/FormButtonDanger";
import useApplyNewStore from "../../store/useApplyNewStore";
import useViewStore from "../../store/useViewStore";
import useModalStore from "../../store/useModalStore";
import { isProduction } from "../../setting";
import DatePickerInput from './datePickerInput/index';
import ToopTipDialog from './ToopTipDialog'
function Step0() {
  const { t } = useTranslation();
  const { Text } = Typography;
  const { step0_Q1, step0_Q1Error, setStep0_Q1, setStep0_Q1Error } = useApplyNewStore();
  const { step0_Q2, step0_Q2Error, setStep0_Q2, setStep0_Q2Error } = useApplyNewStore();
  const { step0_Q3, step0_Q3Error, setStep0_Q3, setStep0_Q3Error } = useApplyNewStore();
  const { step0_Q4, setStep0_Q4 } = useApplyNewStore();
  const { step0_Q5, step0_Q5Error, setStep0_Q5, setStep0_Q5Error } = useApplyNewStore();
  const { step0_Q6, step0_Q6Error, setStep0_Q6, setStep0_Q6Error } = useApplyNewStore();
  const { step0_Q7, step0_Q7Error, setStep0_Q7, setStep0_Q7Error } = useApplyNewStore();
  const { step0_ScrollTo, setStep0_ScrollTo } = useApplyNewStore();
  const { isStep0Valid, validateStep0, goNextStep } = useApplyNewStore();
  const { isMobileView, isPadView } = useViewStore();
  const { openModalConfirm, openModalInfo } = useModalStore();
  const navigate = useNavigate();

  const nodeRef1 = React.useRef(null)
  const nodeRef2 = React.useRef(null)
  const nodeRefFieldQ1 = React.useRef(null)
  const nodeRefFieldQ2 = React.useRef(null)
  const nodeRefFieldQ3 = React.useRef(null)
  const nodeRefFieldQ5 = React.useRef(null)
  const nodeRefFieldQ6 = React.useRef(null)
  const nodeRefFieldQ7 = React.useRef(null)

  const handleOptionClick = (option) => {
    if (option === 1 && step0_Q4 === "spouse_children") {
      setStep0_Q6("");
      setStep0_Q6Error(false);
      setStep0_Q7("");
      setStep0_Q7Error(false);
    } else if (option === 2 && step0_Q4 === "person") {
      setStep0_Q5("");
      setStep0_Q5Error(false);
    }

    setStep0_Q4(option === 1 ? "person" : "spouse_children");
  };

  useEffect(() => {
    const scrollToField = (fieldRef) => {
      fieldRef.current.scrollIntoView({ behavior: 'smooth' });
      setStep0_ScrollTo("");
    };

    const fieldRefs = {
      step0_Q1: nodeRefFieldQ1,
      step0_Q2: nodeRefFieldQ2,
      step0_Q3: nodeRefFieldQ3,
      step0_Q5: nodeRefFieldQ5,
      step0_Q6: nodeRefFieldQ6,
      step0_Q7: nodeRefFieldQ7,
    };

    if (step0_ScrollTo && fieldRefs[step0_ScrollTo]) {
      scrollToField(fieldRefs[step0_ScrollTo]);
    }
  }, [step0_ScrollTo]); 
  
  // 打开tooltip
  const [toopTipDialogOpen,setTooptipOpen]=useState(false);  
  const [isPolicyNo,setIsPolicyNo]=useState(false)
  useEffect(()=>{
   console.log(toopTipDialogOpen,'toopTipDialogOpen');
  }) 
  const handleResetDialog=()=>{
    setTooptipOpen(false);
    setIsPolicyNo(false);
  }
  function yearGen() {
    let result=[];
    let currentYear=new Date().getFullYear();
    for(let i=currentYear;i>=1900;i--){
        let temp={
            label:i,
            value:i+""
        }
        result.push(temp)
    }
    return result;
  } 
  
  function compareDates(targetDateString) {
    // 获取今天的日期
    const today = new Date();
    // 将目标日期字符串转换为Date对象
    const targetDate = new Date(targetDateString);
    // 比较两个日期
    if (targetDate > today) {
      return false;
    } else {
      return true;
    }
  }
  
  const [showLargeToday,setLargeToday]=useState(false);
  const handleDate=(date)=>{
        if(date !== undefined  && !compareDates(date)){
            // 如果大于今天
            setStep0_Q3Error(true);
            setLargeToday(true)
         }else{
           //不大于今天
            setLargeToday(false) 
            date !== undefined && date.length===10 && setStep0_Q3Error(false);
       }
  }
  useEffect(()=>{
    // handleDate(step0_Q3);
    console.log('step0_Q3',step0_Q3,dayjs(step0_Q3).format('YYYY-MM-DD'));
    
  },[step0_Q3])
   return ( 
    <>
    <Container $isMobileView={isMobileView} $isPadView={isPadView} onSubmit={(event) => {
      event.preventDefault();
      if (validateStep0()) {
        goNextStep();
      }
    }}>
      <Flex gap={32} vertical={isPadView}>
        <Flex gap={32} flex={1} vertical>
          <Flex vertical gap={8} style={{ textAlign: "center" }}>
            <FormHeader style={{ marginBottom: 0 }}>{t("translation:apply.step0.sectionLeft.title")}</FormHeader>
            <FormText style={{ fontSize: 16, lineHeight: "26px" }}>{t("translation:apply.step0.sectionLeft.subtitle")}</FormText>
          </Flex>

          <Flex gap={24} vertical>
            <FormField ref={nodeRefFieldQ1} style={{ flex: 0, width: "100%", marginBottom: 0, scrollMarginTop: 90 }}>
              <Flex gap={8}>
                <FormLabel htmlFor="apply_step0_policyNo" style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q1")}</FormLabel>
                <InformationIcon onClick={() => { 
                  setIsPolicyNo(true);
                  setTooptipOpen(true);
                  // window.open(`http://bluecross.com.hk/document/general/supercare_find_policyno/${i18n.language}`, "_blank");
                }}>i</InformationIcon>  
                {/* ws d  */}
              </Flex>
              <FormInput id="apply_step0_policyNo" value={step0_Q1} handleChange={(e) => {
                setStep0_Q1(e.target.value);
                setStep0_Q1Error(false);
              }} placeholder={t("translation:apply.step0.sectionLeft.Q1_placeholder")} aria-label={t("translation:apply.step0.sectionLeft.Q1_placeholder")} />
              <FormInputError show={step0_Q1Error}>* {t("pleaseEnter", { key: t("translation:apply.step0.sectionLeft.Q1") })}</FormInputError>
            </FormField>

            <Flex gap={16} vertical={isMobileView}>
              <FormField ref={nodeRefFieldQ2} style={{ flex: 1, width: "100%", marginBottom: 0, scrollMarginTop: 90 }}>
                <FormLabel htmlFor="apply_step0_name_Of_insuredperson" style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q2")}</FormLabel>
                <FormInput id="apply_step0_name_Of_insuredperson" value={step0_Q2} handleChange={(e) => {
                  setStep0_Q2(e.target.value);
                  setStep0_Q2Error(false);
                }} placeholder={t("translation:apply.step0.sectionLeft.Q2_placeholder")} aria-label={t("translation:apply.step0.sectionLeft.Q2_placeholder")} />

                {
                  step0_Q2Error ?
                    <FormInputError show={true} style={{ marginTop: 4, width: "auto", lineHeight: "16px" }}>* {t("pleaseEnter", { key: t("translation:apply.step0.sectionLeft.Q2") })}</FormInputError>
                    :
                    <FormRemark style={{ marginTop: 4 }}>{t("translation:apply.step0.sectionLeft.Q2_remark")}</FormRemark>
                }
              </FormField>

              <FormField ref={nodeRefFieldQ3} style={{ flex: 1, width: "100%", marginBottom: 0, scrollMarginTop: 90 }}>
                <Flex gap={8}>
                  <FormLabel htmlFor="appy_step0_dob_Of_insuredperson" style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q3")}</FormLabel>
                </Flex>
                {/* ss */}
                <DatePickerInput
                  id="appy_step0_dob_Of_insuredperson"
                  value={step0_Q3}
                  onChange={(date) => { 
                     setStep0_Q3(date);
                     if(date !== undefined  && !compareDates(date)){
                      // 如果大于今天
                      setStep0_Q3Error(true);
                      setLargeToday(true)
                     }else{
                     //不大于今天
                      setLargeToday(false) 
                      date !== undefined && date.length===10 && setStep0_Q3Error(false);
                     }
                  }}
                  yearOptions={yearGen()}
                  monthOptions={[
                    { value: '01', label: '01' },
                    { value: '02', label: '02' },
                    { value: '03', label: '03' },
                    { value: '04', label: '04' },
                    { value: '05', label: '05' },
                    { value: '06', label: '06' },
                    { value: '07', label: '07' },
                    { value: '08', label: '08' },
                    { value: '09', label: '09' },
                    { value: '10', label: '10' },
                    { value: '11', label: '11' },
                    { value: '12', label: '12' },
                  ]}
                  allowClear={false}
                />               
                {step0_Q3Error && !showLargeToday &&<FormInputError show={step0_Q3Error}>* {t("pleaseEnter", { key: t("translation:apply.step0.sectionLeft.Q3") })}</FormInputError>}
                {step0_Q3Error && showLargeToday && <FormInputError show={step0_Q3Error && showLargeToday}>* {t("error:errorMsg:largeToday")}</FormInputError>}
              </FormField>
            </Flex>

            <FormField style={{ flex: 0, width: "100%", marginBottom: 0 }}>
              <FormLabel style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q4")}</FormLabel>
              <Flex vertical={isMobileView} gap={16}>
                <FormBigCheckbox2 
                  id="apply_step0_insuredPolicyID_oneself"
                  onClick={(event) => {
                    event.preventDefault();
                    handleOptionClick(1)
                  }}
                  active={step0_Q4 === "person"}
                  title={t("translation:apply.step0.sectionLeft.Q4_Option1")}
                  style={{ flex: 1 }}
                />
                <FormBigCheckbox2 
                  id="apply_step0_insuredPolicyID_children"
                  onClick={(event) => {
                    event.preventDefault();
                    handleOptionClick(2)
                  }}
                  active={step0_Q4 === "spouse_children"}
                  title={t("translation:apply.step0.sectionLeft.Q4_Option2")}
                  style={{ flex: 1 }}
                />
              </Flex>
            </FormField>

            <CSSTransition
              nodeRef={nodeRef1}
              in={step0_Q4 === "person"}
              timeout={250}
              classNames="fade"
              unmountOnExit
              exit={false}
            >
              <FormField ref={nodeRefFieldQ5} style={{ flex: 0, width: "100%", marginBottom: 0, scrollMarginTop: 90 }}>
                <Flex gap={8}>
                  <FormLabel htmlFor="apply_step0_member_num_Of_Insured" style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q5")}</FormLabel>
                  <InformationIcon onClick={() => { 
                    setTooptipOpen(true);
                    setIsPolicyNo(false);
                 }}>i</InformationIcon>  
                </Flex>
                <FormInput id="apply_step0_member_num_Of_Insured" value={step0_Q5} handleChange={(e) => {
                  setStep0_Q5Error(false);
                  setStep0_Q5(e.target.value);
                }} placeholder={t("translation:apply.step0.sectionLeft.Q5_placeholder")} aria-label={t("translation:apply.step0.sectionLeft.Q5_placeholder")} />
                <FormInputError show={step0_Q5Error}>* {t("pleaseEnter", { key: t("translation:apply.step0.sectionLeft.Q5") })}</FormInputError>
              </FormField>
            </CSSTransition>

            <CSSTransition
              nodeRef={nodeRef2}
              in={step0_Q4 === "spouse_children"}
              timeout={250}
              classNames="fade"
              unmountOnExit
              exit={false}
            >
              <>
                <FormField ref={nodeRefFieldQ6} style={{ flex: 0, width: "100%", marginBottom: 0, scrollMarginTop: 90 }}>
                  <Flex gap={8}>
                    <FormLabel htmlFor="apply_step0_application_insured_no" style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q6")}</FormLabel>
                  </Flex>
                  <FormInput id="apply_step0_application_insured_no" value={step0_Q6} handleChange={(e) => {
                    setStep0_Q6Error(false);
                    setStep0_Q6(e.target.value);
                  }} placeholder={t("translation:apply.step0.sectionLeft.Q6_placeholder")} aria-label={t("translation:apply.step0.sectionLeft.Q6_placeholder")} />
                  <FormInputError show={step0_Q6Error}>* {t("pleaseEnter", { key: t("translation:apply.step0.sectionLeft.Q6") })}</FormInputError>
                </FormField>

                <FormField ref={nodeRefFieldQ7} style={{ flex: 0, width: "100%", marginBottom: 0, scrollMarginTop: 90 }}>
                  <Flex gap={8}>
                    <FormLabel htmlFor="apply_step0_spouse_insured_no" style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q7")}</FormLabel>
                  </Flex>
                  <FormInput id="apply_step0_spouse_insured_no" value={step0_Q7} handleChange={(e) => {
                    setStep0_Q7Error(false);
                    setStep0_Q7(e.target.value);
                  }} placeholder={t("translation:apply.step0.sectionLeft.Q7_placeholder")} aria-label={t("translation:apply.step0.sectionLeft.Q7_placeholder")} />
                  <FormInputError show={step0_Q7Error}>* {t("pleaseEnter", { key: t("translation:apply.step0.sectionLeft.Q7") })}</FormInputError>
                </FormField>
              </>
            </CSSTransition>
          </Flex>
        </Flex>

        <SectionRight vertical flex={1} gap={8} $isPadView={isPadView}>
          <Flex vertical>
            <FormTitle>{t("translation:apply.step0.sectionRight.title")}</FormTitle>
            <FormText>{t("translation:apply.step0.sectionRight.subtitle")}</FormText>
          </Flex>

          <Flex vertical>
            <Flex gap={8} style={{ padding: isPadView ? "24px 0px" : 24 }}>
              <StepCircle>1</StepCircle>
              <Flex style={{ textAlign: "left", marginTop: 2 }} flex={1} vertical gap={4}>
                <FormTitle>{t("translation:apply.step0.sectionRight.step1_title")}</FormTitle>
                <Text><Trans i18nKey="translation:apply.step0.sectionRight.step1_content" components={{ bold: <b /> }} /></Text>
              </Flex>
            </Flex>
            <div style={{ width: "100%", height: 1, backgroundColor: "var(--aia-bx-medium-blue-20)" }} />
            <Flex gap={8} style={{ padding: isPadView ? "24px 0px" : 24 }}>
              <StepCircle>2</StepCircle>
              <Flex style={{ textAlign: "left", marginTop: 2 }} flex={1} vertical gap={4}>
                <FormTitle>{t("translation:apply.step0.sectionRight.step2_title")}</FormTitle>
                <Flex>
                  <Text><Trans i18nKey="translation:apply.step0.sectionRight.step2_content" components={{ bold: <b /> }} /></Text>
                </Flex>
                <Flex>
                  <Flex gap={8} align="center" style={{ cursor: "pointer" }} onClick={() => {
                    openModalInfo({
                      title: t("translation:apply.step0.sectionRight.step2_tip_modal.title"),
                      text: <Flex vertical>
                        <Text>{t("translation:apply.step0.sectionRight.step2_tip_modal.subtitle")}</Text>
                        <ul style={{ fontSize: 14 }}>
                          <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.a")}</li>
                          <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.title")}</li>
                          <ul>
                            <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.list.1")}</li>
                            <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.list.2")}</li>
                            <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.list.3")}</li>
                            <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.list.4")}</li>
                            <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.list.5")}</li>
                            <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.list.6")}</li>
                            <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.list.7")}</li>
                            <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.list.8")}</li>
                            <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.list.9")}</li>
                            <li>{t("translation:apply.step0.sectionRight.step2_tip_modal.content.b.list.10")}</li>
                          </ul>
                        </ul>
                      </Flex>,
                      style: { content: { width: 600 } },
                    });
                  }}>
                    <InformationIcon id="tip2" style={{ margin: 0 }}>i</InformationIcon>
                    <FormTitle>{t("translation:apply.step0.sectionRight.step2_tip")}</FormTitle>
                  </Flex>
                </Flex>
                <DownloadButton id={isProduction ? "pre_auth_learn_download_form_btn_2" : "pre_auth_uat_learn_download_form_btn_2"} onClick={(event) => {
                  event.preventDefault();
                  const url = `${process.env.REACT_APP_PDF_PREFIX}/MC223_Pre-assessment Service (2024_1031).pdf`;
                  window.open(url, '_blank');
                }} style={{ padding: 6 }}>
                  <Flex justify="center" align="center" gap={4}>
                    <ImgDownload />
                    <DownloadButtonText>{t("translation:apply.step0.sectionRight.download")}</DownloadButtonText>
                  </Flex>
                </DownloadButton>
              </Flex>
            </Flex>
          </Flex>
        </SectionRight>
      </Flex>

      <Flex justify={"center"} gap={16} vertical={isMobileView} style={{ flexFlow: isMobileView ? "column-reverse" : "row" }}>
        <FormButtonSecondary onClick={(event) => {
          event.preventDefault();
          openModalConfirm({
            title: t("translation:apply.nav.exitTitle"),
            text: t("translation:apply.nav.exitContent"),
            callback: () => {
              navigate(`${process.env.PUBLIC_URL}/${i18n.language}`, { replace: true });
            }
          });
        }}>{t("back")}</FormButtonSecondary>
        <FormButtonDanger id={isProduction ? "pre_auth_apply_apply_btn" : "pre_auth_uat_apply_apply_btn"} type={"submit"} disabled={!isStep0Valid}>{t("start")}</FormButtonDanger>
      </Flex> 
    </Container>
    {toopTipDialogOpen && <ToopTipDialog openPolicy={isPolicyNo} openModal={toopTipDialogOpen} handleResetDialog={handleResetDialog} />}
    </>

  );
}

const Container = styled.form`
  display: flex;
  width: 95%;
  max-width: 1200px;
  background-color: var(--aia-bx-white);
  ${(props) => props.$isPadView && `flex-direction: column;`}
  ${(props) => props.$isPadView ? `gap: 32px;` : `gap: 56px;`}
  ${(props) => props.$isMobileView ? `padding: 32px 16px;` : `padding: 32px 48px;`}
  margin-bottom: 0px;
  border-radius: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
  flex-direction: column;
`;

const InformationIcon = styled(Flex)`
  background-color: var(--aia-bx-blue-2);
  color: var(--aia-bx-white);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  line-height: 0px;
  cursor: pointer;
  margin-bottom: 8px;
  &:hover {
    background-color: var(--aia-bx-blue-6);
  }
`;

const SectionRight = styled(Flex)`
  background-color: var(--aia-bx-blue-5);
  text-align: center;
  ${(props) => props.$isPadView ? `padding: 16px;` : `padding: 32px 24px;`}
  border-radius: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
  align-self: baseline;
`;

const StepCircle = styled(Flex)`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--aia-bx-blue-2);
  color: var(--aia-bx-white);
  justify-content: center;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
`;

const ImgDownload = styled.div`
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  background-image: url(${process.env.PUBLIC_URL}/images/tray-arrow-d.svg);
`;

const DownloadButtonText = styled.div`
  font-size: 12px;
  color: var(--aia-bx-dark-blue);
`;

const DownloadButton = styled.button`
  border: 1px solid var(--aia-bx-blue-2);
  background-color: var(--aia-bx-white);
  border-radius: 50px;
  cursor: pointer;
  padding: 8px 16px;
  width: auto;
  margin-top: 4px;
  
  &:hover {
    background-color: var(--aia-bx-blue-2);

    ${DownloadButtonText} {
      color: var(--aia-bx-white);
    }

    ${ImgDownload} {
      width: 16px;
      height: 16px;
      background-size: 16px 16px;
      background-image: url(${process.env.PUBLIC_URL}/images/tray-arrow-d-white.svg);
    }
  }
`;

const FormInputError = styled(_FormInputError)`
  width: auto;
`;

export default Step0;